import { FC } from "react";

import { AverageConsumptionLineChart, AverageConsumptionDataPoint } from "../AverageConsumptionLineChart/AverageConsumptionLineChart";
import { AVERAGE_WATER_CONSUMPTION_WASHING_MACHINES_DATA_KEYS } from "./AverageWaterConsumptionWashingMachines.const";

const AverageWaterConsumptionWashingMachines: FC<{ data: AverageConsumptionDataPoint[] }> = ({ data }) => (
	<AverageConsumptionLineChart
		data={data}
		yAxisLabel="Average water consumption of washing machines"
		chartSubtitle="(liters per cycle)"
		yDomain={[0, 70]}
		yTickCount={8}
		dataKeys={AVERAGE_WATER_CONSUMPTION_WASHING_MACHINES_DATA_KEYS}
	/>
);

export { AverageWaterConsumptionWashingMachines };
